import React from 'react';
import { CourseCardSkeletonGroup, CourseCardSkeleton } from '@udemy/react-reveal-components';
import styles from "./course-unit-skeleton.module.css";
export const CourseUnitSkeleton = ({
  className = '',
  layout = 'multirow'
}) => {
  return /*#__PURE__*/React.createElement(CourseCardSkeletonGroup, {
    "data-testid": 'course-unit-skeleton-group',
    className: className,
    rowCount: layout === 'multirow' ? 3 : 1,
    size: layout === 'multirow' ? 'small' : 'medium',
    withTitle: true
  });
};
export const CourseUnitSkeletonVerticalLayout = ({
  cardCount = 3
}) => {
  return /*#__PURE__*/React.createElement("div", {
    className: styles['vertical-layout-wrapper']
  }, Array.from({
    length: cardCount
  }).map((_, index) => /*#__PURE__*/React.createElement("div", {
    key: index,
    className: styles['vertical-layout-card-wrapper']
  }, /*#__PURE__*/React.createElement(CourseCardSkeleton, {
    size: "medium",
    width: "flexible",
    lineCount: 4
  }))));
};
//# sourceMappingURL=course-unit-skeleton.react-component.js.map